import { render, staticRenderFns } from "./addRecedeGoods.vue?vue&type=template&id=4a58226f&scoped=true&"
import script from "./addRecedeGoods.vue?vue&type=script&lang=js&"
export * from "./addRecedeGoods.vue?vue&type=script&lang=js&"
import style0 from "./addRecedeGoods.vue?vue&type=style&index=0&id=4a58226f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a58226f",
  null
  
)

export default component.exports